"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abExperimentsSubscriberSelector = exports.userDataPermissionsSubscriberSelector = exports.userPermissionsSubscriberSelector = exports.userAllPermissionsSubscriberSelector = exports.userDataIsLoadingSubscriberSelector = exports.userDataCriticalActionCodeSubscriberSelector = exports.isCriticalActionIncorrectCodeSubscriberSelector = exports.userDataIsCriticalActionSubscriberSelector = exports.userDataSubscriberSelector = exports.isUserAuthentificatedSubscriberSelector = void 0;
var constants_1 = require("../constants");
var isUserAuthentificatedSubscriberSelector = function (authenticated) { return authenticated || false; };
exports.isUserAuthentificatedSubscriberSelector = isUserAuthentificatedSubscriberSelector;
var userDataSubscriberSelector = function (userData) { return userData || {}; };
exports.userDataSubscriberSelector = userDataSubscriberSelector;
var userDataIsCriticalActionSubscriberSelector = function (isCriticalAction) { return isCriticalAction || false; };
exports.userDataIsCriticalActionSubscriberSelector = userDataIsCriticalActionSubscriberSelector;
var isCriticalActionIncorrectCodeSubscriberSelector = function (isCriticalActionIncorrectCode) { return isCriticalActionIncorrectCode || false; };
exports.isCriticalActionIncorrectCodeSubscriberSelector = isCriticalActionIncorrectCodeSubscriberSelector;
var userDataCriticalActionCodeSubscriberSelector = function (criticalActionCode) { return criticalActionCode || null; };
exports.userDataCriticalActionCodeSubscriberSelector = userDataCriticalActionCodeSubscriberSelector;
var userDataIsLoadingSubscriberSelector = function (isLoading) { return isLoading || false; };
exports.userDataIsLoadingSubscriberSelector = userDataIsLoadingSubscriberSelector;
var userAllPermissionsSubscriberSelector = function (permissions) { return permissions || {}; };
exports.userAllPermissionsSubscriberSelector = userAllPermissionsSubscriberSelector;
var userPermissionsSubscriberSelector = function (scope) { return function (permissions) {
    if (!permissions) {
        return {};
    }
    return permissions[scope] || {};
}; };
exports.userPermissionsSubscriberSelector = userPermissionsSubscriberSelector;
var userDataPermissionsSubscriberSelector = function (scope) { return function (permissionsData) {
    if (!permissionsData) {
        return {};
    }
    return permissionsData[scope] || {};
}; };
exports.userDataPermissionsSubscriberSelector = userDataPermissionsSubscriberSelector;
var abExperimentsSubscriberSelector = function (scope) {
    if (scope === void 0) { scope = constants_1.AB_EXPERIMENTS_SCOPE; }
    return function (permissionsData) {
        if (!permissionsData) {
            return {};
        }
        var permissionsDataByScope = permissionsData[scope] || {};
        var abExperiments = permissionsDataByScope[constants_1.AB_EXPERIMENTS_ABAC_FEATURE];
        return abExperiments;
    };
};
exports.abExperimentsSubscriberSelector = abExperimentsSubscriberSelector;
